<template>
  <div
    ref='root'
    v-show='visible'
    class='popup templates'
  >
    <div class='content'>
      <a class='cc' href='' @click.prevent.stop='' v-html='svg.cc'></a>
      <!-- <div class='pager left'>
        <a v-show='page > 0' @click='onPrevPage'>
          <img src='@/assets/images/ui/templates-left-arrow.png' />
        </a>
      </div> -->
      <ul>
        <li v-for='(template, idx) in templates' :key="idx">
          <a
            class='template-item'
            @click='onSelectTemplate(template)'
            v-bind:disabled='!template.active'
            :class='{ disabled: !template.active }'
          >
            <i class='dummy'></i>
            <div class='thumbnail'><img class="thumbnail-img" v-bind:src='template.img' /></div>
            <span v-text='template.active ? template.name : "coming soon"'></span>
          </a>
        </li>
      </ul>
      <!-- <div class='pager right'>
        <a v-show='templates.length > (page + limit)' @click='onNextPage'>
          <img src='@/assets/images/ui/templates-right-arrow.png' />
        </a>
      </div> -->
    </div>
    <div class='close'>
      <a @click='onClose'>
        <img src='@/assets/images/ui/close.png' />
      </a>
    </div>
  </div>
</template>

<script>

import PopupBase from './PopupBase.vue';

import Template from '@/assets/javascripts/ui/Template';
import svgCC from '@/assets/images/ui/cc.svg';
import pngStool from '@/assets/images/templates/template-stool.png';
// import pngTable from '@/assets/images/templates/template-table.png';
// import pngShelf from '@/assets/images/templates/template-shelf.png';
import pngBench from '@/assets/images/templates/template-bench.png';
import pngBoardRound from '@/assets/images/templates/template-board-round.png';
import pngBoardRec from '@/assets/images/templates/template-board-rec.png';

export default {
  name: 'TemplatesPopup',
  extends: PopupBase,
  components: {
  },

  props: {
  },

  computed: {
  },

  data () {
    return {
      svg: {
        cc: svgCC
      },
      page: 0,
      limit: 3,
      templates: [
        new Template('スツール', '6ddff61a-4f02-11ea-b6dd-8c8590b79a1f.ghx', pngStool, true),
        // new Template('table', 'cb7506f0-4ef1-11ea-b638-8c8590b79a1f.ghx', pngTable, true),
        // new Template('shelf', 'emarf_shelf_190927.ghx', pngShelf, false)
        new Template('ベンチ', '01-bench.ghx', pngBench, true),
        new Template('天板（四角）', '02-tenban-shikaku.ghx', pngBoardRec, true),
        new Template('天板（丸）', '03-tenban-circle.ghx', pngBoardRound, true),
      ]
    };
  },

  mounted () {
  },

  methods: {
    onSelectTemplate (template) {
      if (template.active) {
        this.$emit('selecttemplate', template);
        this.onClose();
      }
    },

    onPrevPage () {
      this.page--;
    },

    onNextPage () {
      this.page++;
    }
  }
};

</script>

<style lang="scss" scoped>
ul{
  // width: 700px !important;
  .thumbnail{
    padding: 1rem;
    .thumbnail-img{
      width: 100%;
      height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TemplatesPopup.vue